<template>
  <div id="header"
       class="clearfix"
       v-if="headerIsShow">
    <div class="tohomepage"
         @click="goBack">
      <img src="../../assets/img/back.png" />
    </div>
    <span class="examplename">{{examplename}}</span>
  </div>
</template>
<script>
export default {
  name: "G-header",
  data () {
    return {
      msg: "页面顶部"
    };
  },
  props: {
    headerIsShow: {
      type: Boolean,
      default: true
    },
    examplename: {
      type: String,
      default: ""
    }
  },
  mounted () { },
  methods: {
    goBack () {
      this.$router.replace("/");
    }
  }
};
</script>
<style lang="less">
#header {
  background: #c8161d;
  // border-bottom: 1px solid #c8161d;
  text-align: center;
  .tohomepage {
    height: 100%;
    line-height: 40px;
    padding: 0 5px;
    position: absolute;
    left: 10px;
    display: flex;
    align-content: center;
    align-items: center;
    > img {
      height: 18px;
    }
  }
  .examplename {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobleHeader/index.vue